var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account"},[_c('h2',[_vm._v("Minha conta")]),_c('div',{staticClass:"panel"},[_c('info'),_c('address-form'),_c('password')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }